export default "__VITE_ASSET__BSul$mdZ__"